export type TransactionCodeOptions = {
  prefix?: string;
  randomLength?: number;
  includeTime?: boolean;
};

function pad2(n: number) {
  return String(n).padStart(2, '0');
}

function nowStamp(includeTime: boolean) {
  const d = new Date();
  const y = d.getFullYear();
  const m = pad2(d.getMonth() + 1);
  const day = pad2(d.getDate());
  if (!includeTime) return `${y}${m}${day}`;
  const hh = pad2(d.getHours());
  const mm = pad2(d.getMinutes());
  const ss = pad2(d.getSeconds());
  return `${y}${m}${day}-${hh}${mm}${ss}`;
}

function randomBase32(len: number) {
  const alphabet = 'ABCDEFGHJKLMNPQRSTUVWXYZ23456789';
  const bytes = new Uint8Array(len);
  crypto.getRandomValues(bytes);
  let out = '';
  for (let i = 0; i < len; i++) out += alphabet[bytes[i] % alphabet.length];
  return out;
}

export function generateTransactionCode(opts?: TransactionCodeOptions) {
  const prefix = opts?.prefix ?? 'PF-TX';
  const randomLength = Math.max(4, Math.min(20, opts?.randomLength ?? 6));
  const includeTime = opts?.includeTime ?? true;
  const stamp = nowStamp(includeTime);
  const rnd = randomBase32(randomLength);
  return `${prefix}-${stamp}-${rnd}`;
}

export function isValidTransactionCode(code: string, prefix = 'PF-TX') {
  const re = new RegExp(`^${prefix}-\\d{8}(?:-\\d{6})?-([A-Z2-9]{4,20})$`);
  return re.test(code);
}
